<template>
  <wc-dialog
    :showDialog='showDialog'
    title='Contact'
    icon='mdi-magnify'
    hideCancel
    saveText='Close'
    @save="$emit('close')"
    width='350'
  >
    <template v-slot:dialog-form>
      <v-alert v-if="contact.archived" border='bottom' type='error' icon='mdi-archive' class='mx-2'>This Client has been Archived</v-alert>
      <v-alert v-if="contact.on_hold && !contact.archived" border='bottom' type='error' :icon='$icons.hold.icon' class='mx-2'>This Client has been placed on hold</v-alert>
      <br>
      <v-card-text>
        <h2>
          {{ contact.name_display }}<br>
          <small class='grey--text'>{{ contact.contact_type }}</small>
        </h2>
        <br>
        <address>
          {{ contact.address }}<br>
          {{ contact.city }} {{ contact.province }}<br>
          {{ contact.country }}
        </address>
      </v-card-text>
      <v-divider></v-divider>
      <v-simple-table dense>
        <tbody>
          <tr><td :class='label'>Email</td><td :class='dataValue'>{{ contact.email }}</td></tr>
          <tr><td :class='label'>Home</td><td :class='dataValue'>{{ contact.home_phone }}</td></tr>
          <tr><td :class='label'>Cell</td><td :class='dataValue'>{{ contact.cell_phone }}</td></tr>
          <tr><td :class='label'>Work</td><td :class='dataValue'>{{ contact.work_phone }}<span v-if='contact.work_phone_extension'>{{" ext. " + contact.work_phone_extension }}</span></td></tr>
        </tbody>
      </v-simple-table>
      <v-divider></v-divider>
    </template>
    <template v-slot:dialog-actions>
      <v-btn text small color='info' :to="{ name: 'ClientOverview', params: { id: contact.id } }">
        Open Record
      </v-btn>
    </template>

  </wc-dialog>
</template>

<script>
export default {
  name: 'wc-contact-card-dialog',
  props: {
    contact: {
      required: true
    },
    showDialog: {
      required: true
    }
  },
  data: () => ({
    label: 'grey--text',
    dataValue: 'text-right pr-2'
  })
}
</script>
